export default __webpack_public_path__ + "static/media/distribution_powerline_icon.db50cbf9.svg";